/* eslint-disable import/order */
import { MenuIdPlans } from '@jira/navigation-apps__constants/src/MenuIdPlans.tsx';
import {
	advancedRoadmapsPlanPageInitialChecksResource,
	advancedRoadmapsReduxStoreStateResource,
	advancedRoadmapsLastVisitedProgramBoardIdResource,
} from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { getPlansBacklogResource } from '@jira/router-resources__advanced-roadmaps-plan/src/plansBacklogResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarPlanResources,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { planPageRoute } from '@jira/router-routes__advanced-roadmaps-routes/src/planPageRoute.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { planLayout } from '@jira/platform__layouts-jira-plan-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import PlanTimelinePage, { LazyPlanTimeline } from './ui/plan-timeline/index-old.tsx';
import { withRedirection } from './ui/utils.tsx';

// This redirect is required to support legacy routes, it should never be deleted
const planPageRedirect = withRedirection(PlanTimelinePage, {
	to: '/timeline',
	redirectCondition: () => true,
});

export const planPageRouteEntry: Route = createEntry(planPageRoute, () => ({
	group: 'software',
	ufoName: 'software-advanced-roadmaps-scenario',
	// eslint-disable-next-line no-restricted-syntax
	component: planPageRedirect,
	layout: composeLayouts(globalLayout, planLayout),

	resources: [
		...getNavigationResources(),
		...getNavigationSidebarPlanResources(),
		advancedRoadmapsPlanPageInitialChecksResource,
		...getPlansBacklogResource(),
		advancedRoadmapsReduxStoreStateResource,
		advancedRoadmapsLastVisitedProgramBoardIdResource,
	],

	preloadOptions: {
		earlyChunks: ['advanced-roadmaps-early-entry'],
	},

	navigation: {
		menuId: MenuIdPlans,
	},

	forPaint: [LazyAtlassianNavigation, LazyPlanTimeline],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
